import { Inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ENV_CONFIG, EnvironmentConfig, APP_INSIGHTS } from '../../environments/environment.model';
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {
  constructor(@Inject(APP_INSIGHTS) public appInsights: ApplicationInsights) {
    // this.appInsights.loadAppInsights();
    // this.loadCustomTelemetryProperties();
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
    if (properties)
      Sentry.captureEvent({ message: name, breadcrumbs: Object.keys(properties).map(val => ({[val] : properties[val]})) })
    else
      Sentry.captureEvent({ message: name })
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
    Sentry.setMeasurement(name, average, 'units');
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    Sentry.captureException(exception);
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
    Sentry.addBreadcrumb({ message, ...properties });
  }

  private loadCustomTelemetryProperties() {
    this.appInsights.addTelemetryInitializer(envelope => {
      var item = envelope.baseData || {};
      item["properties"] = item["properties"] || {};
      item["properties"]["ApplicationPlatform"] = "WEB";
      item["properties"]["ApplicationName"] = "ProductSelector.Client";
    }
    );
  }
}
